// extracted by mini-css-extract-plugin
export default {"terms":"checkout__terms","error-box":"checkout__error-box","optout":"checkout__optout","displayEmailOptIn":"checkout__displayEmailOptIn","VAT":"checkout__VAT"};